import ProductCrud from './ProductCrud'
export {ProductCrud}
export default ProductCrud
